var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`fnss-card-item vux-1px-b fnss-card-item-${_vm.type}`},[(_vm.type === 'vertical')?[_vm._t("default")]:[_c('div',{staticClass:"fnss-card-item-left"},[_vm._v("\n      "+_vm._s(_vm.term)+"\n    ")]),_c('div',{staticClass:"fnss-card-item-right"},[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }